export const CONSTANT = {
  ASPECT_RATIO_IN_BRAND_INFO: 1,
  ASPECT_RATIO_IN_BRANDING: 27 / 11,
  BUTTON_TEXT_COLOR: "BTC",
  BACKGROUND_COLOR: "BC",
  TEXT_COLOR: "TC",
};
